import React from 'react';
import PropTypes from 'prop-types';

import { pure } from '@dbk/ui-react-utils';
import Text from '../../../common/text';
import { NO_DATA } from '../../../../constants';
import { ChangeIndicatedPercent } from '../../../common/number';
import { injectIntl } from 'react-intl';
import styles from './asset-item-header.styles';

function AssetItemHeaderChange(props) {

  let { value } = props;

  if (value === null) {
      return (
      <div aria-label={props.intl.messages['app.common.nullValue']}>
        <Text>{NO_DATA}</Text>
      </div>
    )
  }

  if (typeof value !== 'number') {
  	value = 0;
  }
  return (
    <ChangeIndicatedPercent value={value} withPlusSign renderProps={{ size:'small', style: styles.assestItemHeaderChange}}/>
  );
}

AssetItemHeaderChange.propTypes = {
  value: PropTypes.number,
};

AssetItemHeaderChange.contextTypes = {
  intl: PropTypes.object,
};

export default pure(injectIntl(AssetItemHeaderChange));
